export default function FrostLogo({
  className,
  size = 28
}: {
  className?: string;
  size?: number;
}) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 64 64"
      fill="none"
      width={size}
      height={size}
      className={className}
      aria-hidden="true"
    >
      <defs>
        <linearGradient id="fb-logo" x1="0" y1="0" x2="64" y2="64" gradientUnits="userSpaceOnUse">
          <stop offset="0" stopColor="#7FB7E8" />
          <stop offset="1" stopColor="#1E4A8C" />
        </linearGradient>
      </defs>
      <g stroke="url(#fb-logo)" strokeWidth="3" strokeLinecap="round">
        <line x1="32" y1="8" x2="32" y2="56" />
        <line x1="11" y1="20" x2="53" y2="44" />
        <line x1="11" y1="44" x2="53" y2="20" />
        <g>
          <polyline points="27,12 32,17 37,12" />
          <polyline points="27,52 32,47 37,52" />
        </g>
        <g>
          <polyline points="13,14 15.5,20.5 22,23" />
          <polyline points="51,50 48.5,43.5 42,41" />
        </g>
        <g>
          <polyline points="13,50 15.5,43.5 22,41" />
          <polyline points="51,14 48.5,20.5 42,23" />
        </g>
      </g>
      <circle cx="32" cy="32" r="3.5" fill="url(#fb-logo)" />
    </svg>
  );
}
